import { render, staticRenderFns } from "./DocumentosLicitacao.vue?vue&type=template&id=72b73c0e"
import script from "./DocumentosLicitacao.vue?vue&type=script&lang=js"
export * from "./DocumentosLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports